var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repeat-option-warning"},[_c('strong',[_vm._v("\n\t\t"+_vm._s(_vm.$t('calendar', 'This event is the recurrence-exception of a recurrence-set. You cannot add a recurrence-rule to it.'))+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }